import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import ExtendPaymentReminder from "./ExtendPaymentReminder";
export const ShowPaymentReminder = () => {
  const { id } = useParams();

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendPaymentReminder
        row={{ id, onUpdate: () => {}, onDelete: () => {} }}
      />
    </Box>
  );
};
